<template>
  <div v-if="showScreen">
    <div class="mt-3 row">
      <div class="mx-auto col-lg-9 col-xs-12">
        <div class="row align-center">
          <div class="col-xm-11 col-md-6 mb-3">
            <botao-duvidas></botao-duvidas>
          </div>
        </div>
        <div class="alert alert-warning" v-if="error">{{ error }}</div>
        <div class="card">
          <div class="card-body p-3">
            <div class="form-group mb-3">
              <label for="cpf">CPF do beneficiário:</label>

              <div>
                <the-mask
                  id="cpf"
                  name="cpf"
                  pattern="[0-9\.\-]*"
                  inputmode="numeric"
                  mask="###.###.###-##"
                  type="text"
                  :masked="false"
                  placeholder="000.000.000-00"
                  :class="`form-control` + ($v.cpf.$error ? ` is-invalid` : ``)"
                  v-model="$v.cpf.$model"
                  @change="$v.cpf.$touch()"
                  @keyup.enter="entrar"
                  autofocus
                ></the-mask>
                <b-tooltip
                  target="cpf"
                  variant="info"
                  triggers="focus"
                  placement="left"
                >
                  <small>Insira aqui o seu CPF.</small>
                </b-tooltip>
              </div>
              <div class="error" v-if="$v.cpf.$error">
                <div v-if="!$v.cpf.required">
                  <small>Este campo é obrigatório.</small>
                </div>
                <div v-if="!$v.cpf.numeric">
                  <small>Este campo aceita apenas valores numéricos.</small>
                </div>
                <div v-if="!$v.cpf.isCpf">
                  <small>CPF inválido.</small>
                </div>
              </div>
            </div>

            <div class="form-group mb-3">
              <label for="nome">Primeiro nome do beneficiário:</label>

              <div>
                <input
                  id="nome"
                  type="text"
                  :class="
                    `form-control` + ($v.nome.$error ? ` is-invalid` : ``)
                  "
                  name="nome"
                  placeholder="Apenas letras"
                  v-model.trim="$v.nome.$model"
                  @change="$v.nome.$touch()"
                  @keyup.enter="entrar"
                />
                <b-tooltip
                  target="nome"
                  variant="info"
                  triggers="focus"
                  placement="left"
                >
                  <small>Primeiro nome do detentor do CPF informado.</small>
                </b-tooltip>
              </div>
              <div class="error" v-if="$v.nome.$error">
                <div v-if="!$v.nome.required">
                  <small>Este campo é obrigatório.</small>
                </div>
                <div v-if="!$v.nome.minLength">
                  <small>Este campo deve possuir pelo menos 3 letras.</small>
                </div>
              </div>
            </div>

            <button
              type="submit"
              @click="entrar"
              class="btn btn-primary btn-block"
            >
              Entrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!------------- botoes contato   ------------------------->
    <div class="container">
      <b-row class="my-3">
        <b-col class="text-center">
          <div>
            <small class="text-muted">Fale conosco:</small>
          </div>
          <a
            class="btn btn-sm btn-link text-dark"
            title="Contate-nos via Email"
          >
            <div class="row">
              <div class="col-2">
                <font-awesome-icon
                  size="2x"
                  :icon="['fas', 'at']"
                  title="Contate-nos via Email"
                />
              </div>
              <div class="col text-left d-none d-md-block">estamosjuntos@pbh.gov.br</div>
            </div>
          </a>
        </b-col>
        <!--<botoes-contato "></botoes-contato>-->
      </b-row>
    </div>

    <b-modal v-model="modalShow" title="ALERTA" ok-only centered>
      <p>{{ erroModal }}</p>
    </b-modal>

    <b-modal
      scrollable
      size="lg"
      header-bg-variant="warning"
      v-model="modalShowCpIrregular"
      title="ALERTA"
      ok-only
      centered
    >
      <p>
        Senhor(a) beneficiário(a), informamos que foi identificado uma
        irregularidade no seu CPF junto a Receita Federal que impede o pagamento
        do(s) auxílio(s) solicitado(s) do Programa Auxílio Belo Horizonte.
      </p>
      <p>
        Portanto, para que sua família possa receber o(s) auxílio(s)
        solicitado(s), é necessário que o Sr.(a) realize a regularização do seu
        CPF junto a Receita Federal até o dia 15/02/22 ou que realize a
        indicação de outro beneficiário de sua família.
      </p>
      <p>
        Caso sua opção seja por cadastrar outro responsável familiar, este
        deverá pertencer ao seu núcleo familiar, ter CPF regular junto à Receita
        Federal e não estar contemplado no Programa Auxílio Belo Horizonte.
        Recomendamos que a regularidade do CPF a ser cadastrado seja verificada
        no site da Receita Federal disponível no link:
        <b-link
          href="https://servicos.receita.fazenda.gov.br/servicos/cpf/consultasituacao/consultapublica.asp"
          >https://servicos.receita.fazenda.gov.br/servicos/cpf/consultasituacao/consultapublica.asp</b-link
        >
      </p>
      <p>
        O cadastramento de outro responsável familiar estará disponível a partir
        do dia 20/01/22, com todas as orientações necessárias para sua
        realização, caso essa seja a sua opção.
      </p>
      <p></p>
      A regularização do seu CPF ou indicação de outro responsável familiar com
      CPF regular é indispensável para o pagamento do(s) auxílio(s)
      solicitado(s).
    </b-modal>
  </div>
</template>

<script>
import api from "../requests";
import { validaCPF } from "../validations/index";
import { TheMask } from "vue-the-mask";
import {
  required,
  minLength,
  numeric,
  // helpers
} from "vuelidate/lib/validators";

export default {
  components: {
    TheMask,
    //"botoes-contato": require("./layout/BotoesContato").default,
    "botao-duvidas": require("./layout/BotaoDuvidas").default,
  },
  data() {
    return {
      cpf: "",
      nome: "",
      validCaptcha: false,
      error: null,
      modalShow: false,
      modalShowCpIrregular: false,
      erroModal: "",
    };
  },
  validations: {
    cpf: {
      required,
      numeric,
      isCpf: (cpf) => validaCPF(cpf),
    },
    nome: {
      required,
      minLength: minLength(3),
    },
  },
  computed: {
    http() {
      return this.$store.getters.http;
    },
    token() {
      return this.$store.getters.token;
    },
    showScreen() {
      return this.$store.getters.showScreen;
    },
  },
  watch: {},
  methods: {

    async entrar() {
      this.error = null;
      this.$store.commit("setLoading", true);

      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$Progress.start();

        try {
          if(this.nome.indexOf(' ') >= 0){
            this.erroModal = 'Digite apenas seu primeiro nome.';
            this.modalShow = true;
            return;
          }
          const params = new FormData();
          params.append("cpf", this.cpf);
          params.append("nome", this.nome);

          const result = await api.post(`busca-dados`, params);

          /*if(result.data.erro === 'true' && result.status === 201) {
            this.modalShowCpIrregular = true;
          }else*/ if (result.data.erro === "true" && result.status != 201) {
            if(result.data.message.nome) {
              this.erroModal = 'O campo nome deve conter somente letras.';
            } else if (result.data.message.cpf){
              this.erroModal = 'O campo :attribute deve ser um número.';
            } else{
              this.erroModal = result.data.message;
            }
            
            this.modalShow = true;
          } else {
            await this.$store.dispatch("gravaDadosForm", {
              cpf: result.data.dados.familia.cpf_requerente,
              nome: result.data.dados.familia.nome_completo,
              beneficios: result.data.dados.beneficios,
              familia: result.data.dados.familia,
            });
            this.$router.push("info");
          }

          this.$store.commit("setLoading", false);
          this.$Progress.finish();
        } catch (e) {
          this.$store.commit("setLoading", false);
          this.$Progress.fail();
          this.error = e;
        }
      } else {
        this.$store.commit("setLoading", false);
      }
    },
    cestaEstudante() {
      const win = window.open("https://cestaestudante.pbh.gov.br", "_blank");
      win.focus();
    },
  },
  async mounted() {
    if (this.$store.getters.retornoComDados) {
      this.$v.cpf.$model = this.$store.getters.cpf;
      this.$v.nome.$model = this.$store.getters.nome;
    } else {
      this.$store.dispatch("flushDados");
    }
  },
};
</script>

<style scoped>
.error {
  color: #dc3545;
}
</style>
